var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CircularBuffer } from '../../dataStructures/CircularBuffer';
import { MathHelper } from '../../helpers/MathHelper';
import { Color } from '../../types/Enums';
import { Easing } from '../../types/Types';
export var DragBoxEvent;
(function (DragBoxEvent) {
    DragBoxEvent["ScrollProgressVertical"] = "scrollProgressVertical";
    DragBoxEvent["ScrollProgressHorizontal"] = "scrollProgressHorizontal";
})(DragBoxEvent || (DragBoxEvent = {}));
var DragBox = (function (_super) {
    __extends(DragBox, _super);
    function DragBox(scene, config) {
        var _this = _super.call(this, scene, config.position.x, config.position.y) || this;
        _this.config = config;
        _this.lastDragValueVertical = 0;
        _this.lastDragValueHorizontal = 0;
        _this.dragForceVertical = 0;
        _this.dragForceHorizontal = 0;
        var bufferSize = 10;
        _this.mostRecentDragValuesVertical = new CircularBuffer(bufferSize);
        _this.mostRecentDragValuesHorizontal = new CircularBuffer(bufferSize);
        _this.isDraggable = true;
        _this.initializeDraggableSpace();
        _this.content = config.content;
        _this.updateMask();
        _this.add([
            _this.draggableSpace,
            _this.content,
        ]);
        _this.setSize(_this.draggableSpace.width, _this.draggableSpace.height);
        _this.moveContentToBeginning();
        _this.scene.add.existing(_this);
        _this.bindEventHandlers();
        return _this;
    }
    DragBox.prototype.preUpdate = function () {
        if (this.isDraggable) {
            if (this.config.horizontal) {
                if (this.dragForceHorizontal !== 0) {
                    this.dragContentHorizontallyByValue(this.dragForceHorizontal);
                    this.dragForceHorizontal = this.updateDragForce(this.dragForceHorizontal);
                    this.emit(DragBoxEvent.ScrollProgressHorizontal, this.getScrollProgressHorizontal());
                }
            }
            else if (this.dragForceVertical !== 0) {
                this.dragContentVerticallyByValue(this.dragForceVertical);
                this.dragForceVertical = this.updateDragForce(this.dragForceVertical);
                this.emit(DragBoxEvent.ScrollProgressVertical, this.getScrollProgressVertical());
            }
            this.mostRecentDragValuesHorizontal.push(0);
            this.mostRecentDragValuesVertical.push(0);
        }
    };
    DragBox.prototype.enableDrag = function (enable) {
        if (enable === void 0) { enable = true; }
        if (this.isDraggable === enable) {
            return;
        }
        if (!enable) {
            this.stopDragForce();
        }
        this.scene.input.setDraggable(this.draggableSpace, enable);
        this.isDraggable = enable;
    };
    DragBox.prototype.moveContentToBeginning = function () {
        if (this.config.horizontal) {
            this.content.x = this.draggableSpaceLeft;
            return;
        }
        this.content.y = this.draggableSpaceTop;
    };
    DragBox.prototype.moveContentTo = function (progress, duration) {
        if (duration === void 0) { duration = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var clampedProgress, dimensionDifference, targetPosition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clampedProgress = Phaser.Math.Clamp(progress, 0, 1);
                        dimensionDifference = this.config.horizontal ?
                            this.content.displayWidth - this.draggableSpace.displayWidth + this.getHorizontalMargin() :
                            this.content.displayHeight - this.draggableSpace.displayHeight + this.getVerticalMargin();
                        targetPosition = this.config.horizontal ?
                            this.draggableSpaceLeft - (clampedProgress * dimensionDifference) :
                            this.draggableSpaceTop - (clampedProgress * dimensionDifference);
                        if (duration === 0) {
                            if (this.config.horizontal) {
                                this.content.x = targetPosition;
                                this.emit(DragBoxEvent.ScrollProgressHorizontal, clampedProgress);
                            }
                            else {
                                this.content.y = targetPosition;
                                this.emit(DragBoxEvent.ScrollProgressVertical, clampedProgress);
                            }
                            return [2];
                        }
                        return [4, this.moveContentToAnimation(targetPosition, duration)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    DragBox.prototype.moveContentToAnimation = function (targetPosition, duration) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        _this.scene.tweens.addCounter({
                            duration: duration,
                            from: _this.config.horizontal ? _this.content.x : _this.content.y,
                            to: targetPosition,
                            ease: Easing.BackEaseOut,
                            onUpdate: function (tween) {
                                if (_this.config.horizontal) {
                                    _this.content.x = tween.getValue();
                                    _this.emit(DragBoxEvent.ScrollProgressHorizontal, _this.getScrollProgressHorizontal());
                                }
                                else {
                                    _this.content.y = tween.getValue();
                                    _this.emit(DragBoxEvent.ScrollProgressVertical, _this.getScrollProgressVertical());
                                }
                            },
                            onComplete: function () {
                                resolve();
                            },
                        });
                    })];
            });
        });
    };
    DragBox.prototype.moveContentBy = function (moveBy, duration, easing) {
        var _this = this;
        if (moveBy === 0) {
            return;
        }
        var from = 0;
        var to = 0;
        if (this.config.horizontal) {
            from = this.content.x;
            to = this.content.x - moveBy;
            if (moveBy > 0 && !this.canDragRight(moveBy)) {
                to = this.draggableSpaceRight + -this.content.displayWidth;
            }
            if (moveBy < 0 && !this.canDragLeft(moveBy)) {
                to = this.draggableSpaceLeft;
            }
        }
        else {
            from = this.content.y;
            to = this.content.y - moveBy;
            if (moveBy > 0 && !this.canDragDown(moveBy)) {
                to = this.draggableSpaceBottom - this.content.displayHeight;
            }
            if (moveBy < 0 && !this.canDragUp(moveBy)) {
                to = this.draggableSpaceTop;
            }
        }
        var tween = this.scene.tweens.addCounter({
            duration: duration,
            from: from,
            to: to,
            ease: easing !== null && easing !== void 0 ? easing : Easing.BackEaseOut,
            onUpdate: function () {
                if (_this.config.horizontal) {
                    _this.content.x = tween.getValue();
                    _this.emit(DragBoxEvent.ScrollProgressHorizontal, _this.getScrollProgressHorizontal());
                }
                else {
                    _this.content.y = tween.getValue();
                    _this.emit(DragBoxEvent.ScrollProgressVertical, _this.getScrollProgressVertical());
                }
            },
        });
    };
    DragBox.prototype.stopDragForce = function () {
        if (this.dragForceVertical !== 0) {
            this.dragForceVertical = 0;
            this.lastDragValueVertical = 0;
            this.mostRecentDragValuesVertical.clear();
        }
        if (this.dragForceHorizontal !== 0) {
            this.dragForceHorizontal = 0;
            this.lastDragValueHorizontal = 0;
            this.mostRecentDragValuesHorizontal.clear();
        }
    };
    DragBox.prototype.changeDraggableSpacePosAndSize = function (position, dimensions, maskPosition) {
        this.setPosition(position.x, position.y);
        this.draggableSpace.displayWidth = dimensions.x;
        this.draggableSpace.displayHeight = dimensions.y;
        this.updateDraggableSpaceEdges();
        this.draggableSpace.setInteractive();
        this.updateMask(maskPosition);
    };
    DragBox.prototype.updateMask = function (maskPosition) {
        var _a, _b, _c;
        this.clearMask();
        (_b = (_a = this.myMask) === null || _a === void 0 ? void 0 : _a.geometryMask) === null || _b === void 0 ? void 0 : _b.destroy();
        (_c = this.myMask) === null || _c === void 0 ? void 0 : _c.destroy();
        this.myMask = this.createMask(maskPosition);
        this.setMask(this.myMask);
    };
    DragBox.prototype.repositionContent = function () {
        if (this.config.repositionToCenter) {
            if (this.config.horizontal) {
                this.content.y = this.draggableSpace.y - this.content.displayHeight * 0.5;
            }
            else {
                this.content.x = this.draggableSpace.x - this.content.displayWidth * 0.5;
            }
            return;
        }
        this.content.x = this.draggableSpaceLeft;
        this.content.y = this.draggableSpaceTop;
    };
    DragBox.prototype.updateDragForce = function (dragForce) {
        if (Math.abs(dragForce) < 0.05) {
            return 0;
        }
        if (Math.abs(dragForce) < 1) {
            return dragForce * 0.5;
        }
        return dragForce * 0.98;
    };
    DragBox.prototype.createMask = function (maskPosition) {
        var x = this.x - (this.draggableSpace.displayWidth / 2);
        var y = this.y - (this.draggableSpace.displayHeight / 2);
        var maskPos = maskPosition !== null && maskPosition !== void 0 ? maskPosition : this.config.maskPosition;
        if (maskPos) {
            x = maskPos.x - (this.draggableSpace.displayWidth / 2);
            y = maskPos.y - (this.draggableSpace.displayHeight / 2);
        }
        var maskShape = this.scene.make.graphics({ fillStyle: { color: Color.Yellow, alpha: 0.5 }, add: false })
            .fillRect(x, y, this.draggableSpace.displayWidth, this.draggableSpace.displayHeight);
        return new Phaser.Display.Masks.GeometryMask(this.scene, maskShape);
    };
    DragBox.prototype.initializeDraggableSpace = function () {
        var _a, _b, _c, _d;
        this.draggableSpace = this.scene.add.rectangle(0, 0, this.config.width, this.config.height, (_b = (_a = this.config.debug) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : Color.Green, ((_c = this.config.debug) === null || _c === void 0 ? void 0 : _c.showDraggableSpace) ? ((_d = this.config.debug.alpha) !== null && _d !== void 0 ? _d : 0.5) : 0);
        this.updateDraggableSpaceEdges();
        this.draggableSpace.setInteractive();
        this.scene.input.setDraggable(this.draggableSpace);
    };
    DragBox.prototype.updateDraggableSpaceEdges = function () {
        this.draggableSpaceTop = this.draggableSpace.y - (this.draggableSpace.displayHeight / 2) + this.getMarginTop();
        this.draggableSpaceBottom = this.draggableSpace.y + this.draggableSpace.displayHeight / 2 - this.getMarginBottom();
        this.draggableSpaceLeft = this.draggableSpace.x - this.draggableSpace.displayWidth / 2 + this.getMarginLeft();
        this.draggableSpaceRight = this.draggableSpace.x + this.draggableSpace.displayWidth / 2 - this.getMarginRight();
    };
    DragBox.prototype.handleDragY = function (dragY) {
        if (!this.isDraggableVertically()) {
            return;
        }
        if (this.dragForceVertical !== 0) {
            this.stopDragForce();
        }
        this.mostRecentDragValuesVertical.push(dragY);
        this.dragContentVerticallyByValue(dragY);
        this.emit(DragBoxEvent.ScrollProgressVertical, this.getScrollProgressVertical());
    };
    DragBox.prototype.handleDragX = function (dragX) {
        if (!this.isDraggableHorizontally()) {
            return;
        }
        if (this.dragForceHorizontal !== 0) {
            this.stopDragForce();
        }
        this.mostRecentDragValuesHorizontal.push(dragX);
        this.dragContentHorizontallyByValue(dragX);
        this.emit(DragBoxEvent.ScrollProgressHorizontal, this.getScrollProgressHorizontal());
    };
    DragBox.prototype.handleDragend = function () {
        if (!this.isDraggableVertically() && !this.isDraggableHorizontally()) {
            return;
        }
        if (this.config.horizontal) {
            var meanDragValueHorizontal = this.getMeanDragValueHorizontal();
            if (Math.abs(meanDragValueHorizontal) > 1.5) {
                this.dragForceHorizontal = meanDragValueHorizontal;
            }
            if (Math.abs(meanDragValueHorizontal) > 10) {
                this.dragForceHorizontal = meanDragValueHorizontal * 3;
            }
            this.lastDragValueHorizontal = 0;
        }
        else {
            var meanDragValueVertical = this.getMeanDragValueVertical();
            if (Math.abs(meanDragValueVertical) > 1.5) {
                this.dragForceVertical = meanDragValueVertical;
            }
            if (Math.abs(meanDragValueVertical) > 10) {
                this.dragForceVertical = meanDragValueVertical * 3;
            }
            this.lastDragValueVertical = 0;
        }
    };
    DragBox.prototype.dragWithWheel = function (dx, dy, wheelEvent) {
        var isTrackpad = false;
        if (wheelEvent.wheelDeltaY) {
            isTrackpad = Math.abs(wheelEvent.wheelDeltaY) !== 120;
        }
        else if (wheelEvent.wheelDeltaX) {
            isTrackpad = Math.abs(wheelEvent.wheelDeltaX) !== 120;
        }
        else if (wheelEvent.deltaMode === 0) {
            isTrackpad = true;
        }
        console.log(isTrackpad ? "Trackpad detected" : "Mousewheel detected");
        if (this.isDraggableVertically()) {
            this.stopDragForce();
            this.moveContentBy((dy || dx) * ((this.config.reverseScrollForTrackpad && isTrackpad) ? -1 : 1), 250, Easing.ExpoEaseOut);
        }
        else if (this.isDraggableHorizontally()) {
            this.stopDragForce();
            this.moveContentBy((-dx || dy) * ((this.config.reverseScrollForTrackpad && isTrackpad) ? -1 : 1), 250, Easing.ExpoEaseOut);
        }
    };
    DragBox.prototype.bindContentHandlers = function () {
        var _this = this;
        this.content.on('dragX', function (dragX) {
            if (_this.isDraggable) {
                _this.handleDragX(dragX);
                _this.emit('dragX', dragX);
            }
        });
        this.content.on('dragY', function (dragY) {
            if (_this.isDraggable) {
                _this.handleDragY(dragY);
                _this.emit('dragY', dragY);
            }
        });
        this.content.on('dragend', function () {
            if (_this.isDraggable) {
                _this.handleDragend();
                _this.emit('dragend');
            }
        });
        this.content.on('pointerdown', function () {
            _this.stopDragForce();
        });
        this.content.on('wheel', function (pointer, dx, dy, dz) {
            _this.dragWithWheel(dx, dy, pointer.event);
        });
    };
    DragBox.prototype.bindEventHandlers = function () {
        var _this = this;
        this.bindContentHandlers();
        this.draggableSpace.on('pointerdown', function () {
            if (!_this.isDraggableVertically() && !_this.isDraggableHorizontally()) {
                return;
            }
            _this.stopDragForce();
        });
        this.draggableSpace.on('wheel', function (pointer, dx, dy, dz) {
            _this.dragWithWheel(dx, dy, pointer.event);
        });
        this.draggableSpace.on('drag', function (pointer, dragX, dragY) {
            if (_this.isDraggableHorizontally()) {
                var dragByHorizontal = _this.lastDragValueHorizontal - dragX;
                _this.lastDragValueHorizontal = dragX;
                _this.handleDragX(dragByHorizontal);
            }
            else if (_this.isDraggableVertically()) {
                var dragByVertical = _this.lastDragValueVertical - dragY;
                _this.lastDragValueVertical = dragY;
                _this.handleDragY(dragByVertical);
            }
        });
        this.draggableSpace.on('dragend', function () {
            _this.handleDragend();
        });
    };
    DragBox.prototype.getScrollProgressVertical = function () {
        return (this.draggableSpaceTop - this.content.y) / this.getHeightDifferenceVertical();
    };
    DragBox.prototype.getScrollProgressHorizontal = function () {
        return (this.draggableSpaceLeft - this.content.x) / this.getHeightDifferenceHorizontal();
    };
    DragBox.prototype.dragContentVerticallyByValue = function (dragBy) {
        if (dragBy > 0) {
            if (!this.canDragDown(dragBy)) {
                this.content.y = this.draggableSpaceBottom - this.content.displayHeight;
                this.stopDragForce();
                return;
            }
        }
        if (dragBy < 0) {
            if (!this.canDragUp(dragBy)) {
                this.content.y = this.draggableSpaceTop;
                this.stopDragForce();
                return;
            }
        }
        this.content.y -= dragBy;
    };
    DragBox.prototype.dragContentHorizontallyByValue = function (dragBy) {
        if (dragBy > 0) {
            if (!this.canDragRight(dragBy)) {
                this.content.x = this.draggableSpaceRight - this.content.displayWidth;
                this.stopDragForce();
                return;
            }
        }
        if (dragBy < 0) {
            if (!this.canDragLeft(dragBy)) {
                this.content.x = this.draggableSpaceLeft;
                this.stopDragForce();
                return;
            }
        }
        this.content.x -= dragBy;
    };
    DragBox.prototype.canDragLeft = function (dragBy) {
        if (dragBy === void 0) { dragBy = 0; }
        return !(this.content.x - dragBy >= this.draggableSpaceLeft);
    };
    DragBox.prototype.canDragRight = function (dragBy) {
        if (dragBy === void 0) { dragBy = 0; }
        return !(this.content.x + this.content.displayWidth - dragBy <= this.draggableSpaceRight);
    };
    DragBox.prototype.canDragUp = function (dragBy) {
        if (dragBy === void 0) { dragBy = 0; }
        return !(this.content.y - dragBy >= this.draggableSpaceTop);
    };
    DragBox.prototype.canDragDown = function (dragBy) {
        if (dragBy === void 0) { dragBy = 0; }
        return !(this.content.y + this.content.displayHeight - dragBy <= this.draggableSpaceBottom);
    };
    DragBox.prototype.getMeanDragValueVertical = function () {
        return MathHelper.toFixedNumber(MathHelper.sum(this.mostRecentDragValuesVertical.getAll()) / this.mostRecentDragValuesVertical.size);
    };
    DragBox.prototype.getMeanDragValueHorizontal = function () {
        return MathHelper.toFixedNumber(MathHelper.sum(this.mostRecentDragValuesHorizontal.getAll()) / this.mostRecentDragValuesHorizontal.size);
    };
    DragBox.prototype.isDraggableVertically = function () {
        if (this.config.horizontal || !this.isDraggable) {
            return false;
        }
        return this.draggableSpace.displayHeight < (this.content.displayHeight + this.getVerticalMargin());
    };
    DragBox.prototype.isDraggableHorizontally = function () {
        if (!this.config.horizontal || !this.isDraggable) {
            return false;
        }
        return this.draggableSpace.displayWidth < (this.content.displayWidth + this.getHorizontalMargin());
    };
    DragBox.prototype.getVisibleVerticalSpaceRatioToContent = function () {
        return this.draggableSpace.displayHeight / (this.content.displayHeight + this.getVerticalMargin());
    };
    DragBox.prototype.getVisibleHorizontalSpaceRatioToContent = function () {
        return this.draggableSpace.displayWidth / (this.content.displayWidth + this.getHorizontalMargin());
    };
    DragBox.prototype.getMyMask = function () {
        return this.myMask;
    };
    DragBox.prototype.getMarginTop = function () {
        var _a, _b;
        return (_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : 0;
    };
    DragBox.prototype.getMarginBottom = function () {
        var _a, _b;
        return (_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.bottom) !== null && _b !== void 0 ? _b : 0;
    };
    DragBox.prototype.getMarginLeft = function () {
        var _a, _b;
        return (_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0;
    };
    DragBox.prototype.getMarginRight = function () {
        var _a, _b;
        return (_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.right) !== null && _b !== void 0 ? _b : 0;
    };
    DragBox.prototype.getDraggableSpaceWidth = function () {
        return this.draggableSpace.displayWidth;
    };
    DragBox.prototype.getDraggableSpaceHeight = function () {
        return this.draggableSpace.displayHeight;
    };
    DragBox.prototype.getHeightDifferenceVertical = function () {
        return this.content.displayHeight + this.getVerticalMargin() -
            this.draggableSpace.displayHeight;
    };
    DragBox.prototype.getHeightDifferenceHorizontal = function () {
        return this.content.displayWidth + this.getHorizontalMargin() -
            this.draggableSpace.displayWidth;
    };
    DragBox.prototype.getVerticalMargin = function () {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = this.config.margin) === null || _c === void 0 ? void 0 : _c.bottom) !== null && _d !== void 0 ? _d : 0);
    };
    DragBox.prototype.getHorizontalMargin = function () {
        var _a, _b, _c, _d;
        return ((_b = (_a = this.config.margin) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = this.config.margin) === null || _c === void 0 ? void 0 : _c.right) !== null && _d !== void 0 ? _d : 0);
    };
    return DragBox;
}(Phaser.GameObjects.Container));
export { DragBox };
